import { useEffect, useRef, useState } from 'react';
import { coverFormat } from './cover-variants';

/** Capture playback before a viewport change replaces the media source. */
export function useCoverFormat(beforeChange: () => void) {
  const [format, setFormat] = useState(() => coverFormat(window.innerWidth, window.innerHeight));
  const current = useRef(format);
  const prepare = useRef(beforeChange);
  prepare.current = beforeChange;
  useEffect(() => {
    const resize = () => {
      const next = coverFormat(window.innerWidth, window.innerHeight);
      if (next === current.current) return;
      prepare.current();
      current.current = next;
      setFormat(next);
    };
    window.addEventListener('resize', resize);
    resize();
    return () => window.removeEventListener('resize', resize);
  }, []);
  return format;
}
